const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
const tolerantParse = require('tolerant-json-parser');

const _ = {
    forEach:    require('lodash/forEach'),
    find:       require('lodash/find'),
    map:        require('lodash/map'),
}

const Globals = require('../../../../../app/globals');
const Strings = require('../../../../../app/shared/Strings');

const ShortCourseEditorStore = require('../../../stores/ShortCourseEditorStore');

const OrganizationStore = require('../../../stores/OrganizationStore');
const OrganizationActions = require('../../../actions/OrganizationActions');

const AIUtils = require('../../../util/AIUtils');

const ServerRequest = require('../../../actions/request');
const KeyboardUtil = require('../../../util/keyboard');
import ErrorBox from '../../common/ErrorBox';
import AutoSizeTextArea from '../../common/AutoSizeTextArea';
import AlwaysScrollToBottom from '../../common/AlwaysScrollToBottom';

// AI Tutor
export class ChatBotActivity extends React.Component {
    constructor(props) {
        super(props);
        this.playStore = this.props.playStore;
        this.pollTaskManager = new ServerRequest.PollTaskManager();
        const cb = this.playStore.getCurrentContentBlock();
        const masteryScore = this.playStore.doc.mastery_score; 

        // flatten bot_options back into chatData
        let { bot_options, ...otherParams} = cb;
        let chatData = {...otherParams, ...bot_options };
        let userName = this.playStore.doc.user.avatar_name || 'Player';
        const doc = this.playStore.doc;
        const node_id = this.playStore.getNodeId();
        const node = _.find(doc.nodes,{node_id});
        
        const channelId = this.playStore.getChannelId();
        let orgState = OrganizationStore.getStateOrganization(channelId);
        let org_boilerplate = this.buildOrgBoilerplate(orgState.orgBoilerplate);
        let doc_boilerplate = doc.client_content.doc_boilerplate || {};
        
        this.aiUtils = new AIUtils({
            doc,
            node,
            chatData, // includes cb_boilerplate
            org_boilerplate,doc_boilerplate,
        });
        
        let {formatText, variableEntries, system_text} = chatData;
        if (formatText && org_boilerplate) {
            system_text = this.aiUtils.makeVariableSubstitutions({formatText, variableEntries});
        }        
        
        let { 
            display_title, 
            chatbot_activity_hash, 
            activity_type, 
            botName, 
            topic, 
            subskill_relations 
        } = chatData;
        
        this.state = {
            display_title, 
            chatbot_activity_hash, 
            activity_type, 
            botName, 
            topic, 
            system_text, 
            subskill_relations,
            chatbotState: {
                // messageHistory: undefined,
            },
            start_time: Date.now(),
            progress:0,
            subskills: {},
            masteryScore,
            userName,
            org_boilerplate,doc_boilerplate,
        };
        
        this.unsubscribes = [
            OrganizationStore.listen(this.onOrgStoreChange)
        ];
    }
    
    componentDidMount() {
        if (!this.state.org_boilerplate) {
            let action_getOrgBoilerplate = uuid.v4();
            this.setState({action_getOrgBoilerplate},()=>{
                const channelId = this.playStore.getChannelId();
                OrganizationActions.getOrgBoilerplate(action_getOrgBoilerplate,channelId);
            })
        }
        else {
            this.startChat();
        }
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // way to check if mounted
        this.pollTaskManager.abandonTasks();
    }

    buildOrgBoilerplate=(orgArray)=>{
        if (!orgArray) {
            return;
        }
        let org_boilerplate = {};
        _.forEach(orgArray,(entry)=>{
            org_boilerplate[entry.string_id] = entry.string_value;
        });
        return org_boilerplate;
    }
    
    onOrgStoreChange=(storeState)=>{
        if (storeState.action.id == this.state.action_getOrgBoilerplate) {
            const channelId = this.playStore.getChannelId();
            let orgState = OrganizationStore.getStateOrganization(channelId);
            let org_boilerplate = this.buildOrgBoilerplate(orgState.orgBoilerplate);
            this.aiUtils.setOrgBoilerplate(org_boilerplate);
            
            const cb = this.playStore.getCurrentContentBlock();

            // flatten bot_options back into chatData
            let { bot_options, ...otherParams} = cb;
            let chatData = {...otherParams, ...bot_options };
            let {formatText, variableEntries, system_text} = chatData;
            if (formatText) {
                system_text = this.aiUtils.makeVariableSubstitutions({formatText, variableEntries});
            }
            this.setState({action_getOrgBoilerplate: null, org_boilerplate, system_text},()=>{
                this.startChat();
            });
        }
    }
    
    startChat=()=>{
        let {botName, topic} = this.state;
        let chatbotState = {
            systemText: this.state.system_text,
            textFromUser: `My name is ${this.state.userName}.`, // 'Hello', // initial user Hello is hidden
            // messageHistory: undefined,
        };
        this.makeChatbotRequest(chatbotState);
    }
    
    parseResponse=(textResponse)=>{
        let response = textResponse; // fallback
        let progress = 0;
        let subskills = {};
        let obj;
        try {
            obj = tolerantParse.parse(textResponse); // JSON.parse(textResponse);
        }
        catch(err) {
            //console.log(err);
            //console.log("failed to parse AI response",textResponse);
            obj = null;
        }
        if (!obj) {
            // try removing line feeds
            console.log("retrying parse after removing line feeds");
            textResponse = textResponse.replace(/[\r\n]+/gm,"");
            try {
                obj = tolerantParse.parse(textResponse); // JSON.parse(textResponse)
            }
            catch(err) {
                console.log(err);
                console.log("failed to parse AI response after removing line feeds",textResponse);
            }
        }
        if (obj) {
            response = obj.response;
            progress =obj.progress;
            _.forEach(obj.subskills,(p,hash)=>{
                subskills[hash] = p;
            });
        }
        console.log("progress:",progress);
        return { response, progress, subskills };
    }
    
    makeChatbotRequest=(chatbotState)=>{
        const usageData = {
            channelId: this.playStore.getChannelId(),
            shortCourseId: this.playStore.getShortCourseId(),
        };
        this.setState({chatbotState,waitingFor: 'assistant', userInput:'', error:null},()=>{
            let data = {...chatbotState, modelId: this.playStore.getAITutorModelId(), usageData};
            let actionId = uuid.v4();
            ServerRequest.makePollTaskRequest(`/authoring/interactive_chatbot`, 'POST', JSON.stringify(data), this.pollTaskManager, actionId)
            .then(({textResponse, messageHistory})=>{
                if (this.unsubscribes && this.state.chatbotState) {
                    let {response,progress,subskills} = this.parseResponse(textResponse);
                    let chatbotState = {...this.state.chatbotState,
                        textResponse:response,
                        messageHistory
                    };
                    this.setState({chatbotState, waitingFor: 'user', progress, subskills});
                }
            })
            .catch((err)=>{
                if (this.unsubscribes) {
                    this.setState({error:err, waitingFor:null});
                }
            });
        });
    }    

    setUserInput=(e)=>{
        this.setState({userInput:e.target.value, error: null});
    }

    handleUserInputKeyDown=(e)=>{
        if (!this.state.chatbotState) {
            return;
        }
        let textFromUser = this.state.userInput.trim();
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            if (!textFromUser) {
                this.setState({error: new Error("Please type something")});
                return;
            }
            let chatbotState = {...this.state.chatbotState,
                textFromUser,
            };
            this.makeChatbotRequest(chatbotState);
        }
    }

    endChatbot=()=>{
        const cb = this.playStore.getCurrentContentBlock();
        const chatbotScores = {};
        let { progress, subskills } = this.state;
        let score = progress || 0;
        _.forEach(cb.subskill_relations,(dummy,hash)=>{
            chatbotScores[hash] = subskills[hash] || score;
        }); 
        let time_played = Date.now() - this.state.start_time;
        this.playStore.actions.finishChatActivity(cb.hash, chatbotScores, time_played);
    }

    render() {
        return (
            <div className="chatbot-activity">
                <div className="content-area">
                    { this.state.chatbotState.messageHistory ? 
                    _.map(this.state.chatbotState.messageHistory,(entry,i)=>{
                        if (i===0) {
                            // suppress initial Hello from user
                            return (
                                <span key={i}/>
                            );
                        }
                        let speaker = '';
                        let textEntry = _.find(entry.content,{type: "text"});
                        let entryText = textEntry ? textEntry.text : '';
                        switch(entry.role) {
                            case 'assistant': {
                                let {response} = this.parseResponse(entryText);
                                entryText = response;
                                speaker = this.state.botName;
                                break;
                            }
                            case 'user':
                                speaker = this.state.userName;
                                break;
                        }
                        let entryRows = entryText.split('\n').length;

                        return (
                            <div className="chatbot-log-row" key={i}>
                                <label>{`${speaker}:`}</label>
                                <AutoSizeTextArea value={entryText} readOnly/>
                            </div>
                        );
                    })
                    : null }
                    { (this.state.waitingFor === 'user') ? 
                    <div className="chatbot-log-row">
                        <label>{`${this.state.userName}:`}</label>
                        <AutoSizeTextArea autoFocus value={this.state.userInput} rows="5" onChange={this.setUserInput} onKeyDown={this.handleUserInputKeyDown}/>
                        <span className="instructions">{this.state.userInput ? 'Press ENTER when finished typing.' : ''}</span>
                    </div>
                    : null }
                    { (this.state.waitingFor === 'assistant') ? 
                    <>
                        { this.state.chatbotState.messageHistory ?
                        <div className="chatbot-log-row">
                            <label>{'User:'}</label>
                            <AutoSizeTextArea readonly value={this.state.chatbotState.textFromUser} readOnly/>
                        </div>
                        : null }
                        <div className="chatbot-log-row">
                            <label>{`${this.state.botName}:`}</label>
                            <span>{'...'}</span>
                            <span className="fa fa-refresh fa-spin"/>
                        </div>
                    </>
                    : null }
                    <AlwaysScrollToBottom/>
                </div>
                <div className="button-area">
                    <button className="btn btn-primary" disabled={this.state.progress < this.state.masteryScore} onClick={this.endChatbot}>
                        {Strings['en'].short_course.chatbot.PASS_BUTTON_TEXT}
                    </button>
                    <button className="btn btn-primary" onClick={this.endChatbot}>
                        {Strings['en'].short_course.chatbot.FAIL_BUTTON_TEXT}
                    </button>
                </div>
            </div>
        );
    }
};

export default ChatBotActivity;